'use client';

import { FC, useEffect } from 'react';
import { QueryContainer } from '@opensearch-project/opensearch/api/_types/_common.query_dsl';

import { useOpenSearchContext, useQueryFilterBuilders } from '../hooks';

interface ConfigureProps {
  hitsPerPage?: number;
  restrictSearchableAttributes?: string[];
  filters?: Record<string, Array<string | number | boolean>>;
}
const Configure: FC<ConfigureProps> = ({
  hitsPerPage = 1000,
  restrictSearchableAttributes,
  filters,
}) => {
  const {
    updatePageSize,
    updateSearchableAttributes,
    updateFixedQueryFiltersByFacets,
  } = useOpenSearchContext();
  const { buildFacetQueryFilters } = useQueryFilterBuilders();

  useEffect(() => {
    updatePageSize(hitsPerPage);
    updateSearchableAttributes(restrictSearchableAttributes);
  }, [hitsPerPage, restrictSearchableAttributes]);

  useEffect(() => {
    updateFixedQueryFiltersByFacets((prev: Record<string, QueryContainer>) => ({
      ...prev,
      ...Object.entries(filters ?? {}).reduce(
        (acc, [attribute, values]) => ({
          ...acc,
          [attribute]: buildFacetQueryFilters(attribute, values),
        }),
        {},
      ),
    }));
    // `buildFacetQueryFilters` changes identity with the store timezone, which
    // the on-sale filter bakes in.
  }, [filters, buildFacetQueryFilters]);

  return null;
};

export { Configure };
